import "./ExcalidrawLogo.scss";

const LogoIcon = () => (
  <svg
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="ExcalidrawLogo-icon"
  >
    <circle cx="10" cy="10" r="5" fill="currentColor" />
    <circle cx="30" cy="10" r="5" fill="currentColor" />
    <circle cx="20" cy="22" r="14" fill="currentColor" />
    <circle cx="14.5" cy="20.5" r="4.25" fill="white" />
    <circle cx="25.5" cy="20.5" r="4.25" fill="white" />
    <circle cx="14.5" cy="20.5" r="2" fill="currentColor" />
    <circle cx="25.5" cy="20.5" r="2" fill="currentColor" />
    <ellipse cx="20" cy="26.5" rx="4.5" ry="3.25" fill="white" />
    <circle cx="20" cy="25.75" r="1.6" fill="currentColor" />
    <path
      d="M17 29c.8 1 1.8 1.5 3 1.5s2.2-.5 3-1.5"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
    />
  </svg>
);

const LogoText = () => (
  <svg
    viewBox="0 0 330 55"
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    className="ExcalidrawLogo-text"
  >
    <text
      x="0"
      y="40"
      fill="currentColor"
      fontSize="38"
      fontWeight="700"
      fontFamily="Virgil, Cascadia, Segoe UI, sans-serif"
      letterSpacing="0.5"
    >
      SashaDRAW
    </text>
  </svg>
);

type LogoSize = "xs" | "small" | "normal" | "large" | "custom" | "mobile";

interface LogoProps {
  size?: LogoSize;
  withText?: boolean;
  style?: React.CSSProperties;
  /**
   * If true, the logo will not be wrapped in a Link component.
   * The link prop will be ignored as well.
   * It will merely be a plain div.
   */
  isNotLink?: boolean;
}

export const ExcalidrawLogo = ({
  style,
  size = "small",
  withText,
}: LogoProps) => {
  return (
    <div className={`ExcalidrawLogo is-${size}`} style={style}>
      <LogoIcon />
      {withText && <LogoText />}
    </div>
  );
};
